import type { Opportunity } from "@/model/DataModel"
import type { CustomView } from "@/utils/ApiClient"
import { NotificationTopic } from "@/graphql"

export enum LinkType {
	PROJECT = "project",
	SAVED_SEARCH = "savedSearch",
}

type ActivityBase = {
	id: string
	notificationTopic: NotificationTopic
	title: string
	readAt: string | null
	timestamp: Date
	actorName: string | null
}

type ProjectActivity = {
	linkType: LinkType.PROJECT
	project: string | null
	projectId: string | null
	targetsCount: number | null
	comment: string | null
	savedSearch: null
	savedSearchId: null
	opportunityIds: string[]
}

type SavedSearchActivity = {
	linkType: LinkType.SAVED_SEARCH
	project: null
	projectId: string | null
	savedSearch: string
	savedSearchId: string | null
	opportunityIds: string[]
}

export type Activity = ActivityBase & (ProjectActivity | SavedSearchActivity)

export type ActivityDetail = {
	activity: Activity
	opportunities: Opportunity[]
	savedSearch: CustomView | null
}
